import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import CrumbButton from './CrumbButton';
import DraggableElement from '../util/draggable_element/DraggableElement';
import { useLocation } from 'react-router-dom';
const FolderPathContainer = _ref => {
  let {
    path,
    setCurrentFolderId,
    modelName,
    showFolderOrFileDropModal,
    setDraggedElement,
    draggedElement,
    setCurrentAction,
    goToFolderQuery,
    getFileUploadersAndVirtualFolderPath,
    userCanDrag = true,
    showPath = true
  } = _ref;
  const [virtualFolderPath, setVirtualFolderPath] = useState([]);
  const {
    search
  } = useLocation();
  const user = useSelector(state => state.auth.user);
  const clickAction = p => {
    if (p.name === modelName) {
      setCurrentFolderId(null);
      goToFolderQuery();
    } else if (p.virtual_folder) {
      goToFolderQuery('', true, p);
    } else {
      setCurrentFolderId(p.id);
      goToFolderQuery(p.id);
    }
  };

  // Filter out Company and ClaimGroup for customer users
  const filterPathForCustomer = pathArray => {
    if ((user === null || user === void 0 ? void 0 : user.account_type) === 'customer') {
      return pathArray.filter(item => item.model_type !== 'Company' && item.model_type !== 'ClaimGroup');
    }
    return pathArray;
  };
  useEffect(() => {
    const modelName = new URLSearchParams(search).get('model_name');
    const modelType = new URLSearchParams(location.search).get('model_type');
    const modelId = new URLSearchParams(search).get('model_id');
    if (!!path.length || !modelType) return;
    if (modelType === 'Company') {
      setVirtualFolderPath([{
        name: modelName,
        model_type: modelType,
        model_id: modelId,
        virtual_folder: true
      }]);
      return;
    }

    // there won't be a path in case of virtual folder
    // so we should get one:
    const getVirtualPath = async () => {
      const virtualPathResponse = await getFileUploadersAndVirtualFolderPath();
      setVirtualFolderPath([...virtualPathResponse.reverse()]);
    };
    getVirtualPath();
  }, [getFileUploadersAndVirtualFolderPath, path.length, search]);
  const renderPath = pathToRender => {
    const filteredPath = filterPathForCustomer(pathToRender);
    return filteredPath.map((p, index) => {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: (p.id || p.model_id) + 'path'
      }, index !== 0 && /*#__PURE__*/React.createElement("span", {
        className: "px-2"
      }, '>'), /*#__PURE__*/React.createElement(DraggableElement, {
        userCanDrag: userCanDrag,
        key: p.id + p.name + 'path',
        parentElementType: 'span',
        element: p,
        onDrop: showFolderOrFileDropModal,
        draggedElement: draggedElement,
        setCurrentAction: setCurrentAction,
        setDraggedElement: setDraggedElement
      }, /*#__PURE__*/React.createElement(CrumbButton, {
        linkName: p.name,
        clickAction: () => clickAction(p)
      })));
    });
  };
  if (!showPath) {
    return '';
  }
  if (!!path.length) {
    return renderPath(path);
  } else {
    return renderPath(virtualFolderPath);
  }
};
export default FolderPathContainer;